"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Adminet API Reference
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0.92
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkOrderRowsToJSON = exports.WorkOrderRowsFromJSONTyped = exports.WorkOrderRowsFromJSON = exports.instanceOfWorkOrderRows = void 0;
var runtime_1 = require("../runtime");
var ItemRow_1 = require("./ItemRow");
var OtherRow_1 = require("./OtherRow");
var PerformanceRow_1 = require("./PerformanceRow");
var PersonPerformanceRow_1 = require("./PersonPerformanceRow");
var WorkRow_1 = require("./WorkRow");
/**
 * Check if a given object implements the WorkOrderRows interface.
 */
function instanceOfWorkOrderRows(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfWorkOrderRows = instanceOfWorkOrderRows;
function WorkOrderRowsFromJSON(json) {
    return WorkOrderRowsFromJSONTyped(json, false);
}
exports.WorkOrderRowsFromJSON = WorkOrderRowsFromJSON;
function WorkOrderRowsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'performanceRows': !(0, runtime_1.exists)(json, 'performanceRows') ? undefined : (json['performanceRows'].map(PerformanceRow_1.PerformanceRowFromJSON)),
        'otherRows': !(0, runtime_1.exists)(json, 'otherRows') ? undefined : (json['otherRows'].map(OtherRow_1.OtherRowFromJSON)),
        'itemRows': !(0, runtime_1.exists)(json, 'itemRows') ? undefined : (json['itemRows'].map(ItemRow_1.ItemRowFromJSON)),
        'workRows': !(0, runtime_1.exists)(json, 'workRows') ? undefined : (json['workRows'].map(WorkRow_1.WorkRowFromJSON)),
        'personPerformanceRows': !(0, runtime_1.exists)(json, 'personPerformanceRows') ? undefined : (json['personPerformanceRows'].map(PersonPerformanceRow_1.PersonPerformanceRowFromJSON)),
    };
}
exports.WorkOrderRowsFromJSONTyped = WorkOrderRowsFromJSONTyped;
function WorkOrderRowsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'performanceRows': value.performanceRows === undefined ? undefined : (value.performanceRows.map(PerformanceRow_1.PerformanceRowToJSON)),
        'otherRows': value.otherRows === undefined ? undefined : (value.otherRows.map(OtherRow_1.OtherRowToJSON)),
        'itemRows': value.itemRows === undefined ? undefined : (value.itemRows.map(ItemRow_1.ItemRowToJSON)),
        'workRows': value.workRows === undefined ? undefined : (value.workRows.map(WorkRow_1.WorkRowToJSON)),
        'personPerformanceRows': value.personPerformanceRows === undefined ? undefined : (value.personPerformanceRows.map(PersonPerformanceRow_1.PersonPerformanceRowToJSON)),
    };
}
exports.WorkOrderRowsToJSON = WorkOrderRowsToJSON;
